import CLIDownload from "../../../../contents/docs/error-tracking/_snippets/cli/download.mdx";
import CLIAuthenticate from "../../../../contents/docs/error-tracking/_snippets/cli/authenticate.mdx";
import CLIInject from "../../../../contents/docs/error-tracking/_snippets/cli/inject.mdx";
import CLIUpload from "../../../../contents/docs/error-tracking/_snippets/cli/upload.mdx";
import StepVerifySymbolSetsUpload from "../../../../contents/docs/error-tracking/_snippets/StepVerifySymbolSetsUpload";
import * as React from 'react';
export default {
  CLIDownload,
  CLIAuthenticate,
  CLIInject,
  CLIUpload,
  StepVerifySymbolSetsUpload,
  React
};